import React from 'react'
import ReactPaginate from 'react-paginate'

const TablePagination = ({ handlePageClick, pageCount , pageClass='page-item', linkClass='page-link' }) => {
    return (
        <ReactPaginate
            previousLabel="<"
            nextLabel=">"
            breakLabel="..."
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            renderOnZeroPageCount={null}
            className={'d-inline-flex pagination'}
            previousClassName={pageClass}
            pageClassName={pageClass}
            nextClassName={pageClass}
            previousLinkClassName={linkClass}
            pageLinkClassName={linkClass}
            nextLinkClassName={linkClass}
            activeClassName={'fw-bold active'}
        />
    )
}

export default TablePagination